import React, { useState,useEffect } from 'react'
import { AddUpdate } from '../../../ApiMethods/ApiMethods';
import { customStyles } from '../Utility/Utility';
import DataTable from 'react-data-table-component';


const UserSummery = () => {
const[summerydata,setSummeryData]=useState([])
 const [startTime, setStartTime] = useState(new Date().toISOString().split("T")[0]);
  const [endTime, setEndTime] = useState(new Date().toISOString().split("T")[0]);
    const [userId, setuserId] = useState("");
    

const fetchSummeryData=async()=>{
  const post={UserID:userId,DateFrom:startTime,DateTo:endTime}
  try {
     const res=await AddUpdate ("Users/UserSummary",post)
    
   
      const data=JSON.parse(res?.data?.data)
      const finaldata=data?.Table
      
      setSummeryData(finaldata)
     

  } catch (error) {
     console.log("error",error)
  }
}

  const columns = [
  {
      name: "Name",
      selector: (row) => row.NickName,
      sortable: true,
      width: "200px",
      cell: (row) => (
        <div
         
        >
          <div>
            {row.NickName}({row.UserID})
          </div>
          <div style={{ fontSize: "12px", color: "#0b0e11ff" }}>
            {row.MobileNo}
          </div>
        </div>
      ),
    },
    
    {
      name: "Total Calls",
      selector: (row) => row.TotalCalls,
      sortable: true,
      
    },
   {
      name: "Total Chats",
      selector: (row) => row.TotalChats,
      sortable: true,
      
    },
   
    {
      name: "Wallet Amount",
      selector: (row) => row.WalletAmt,
      sortable: true,
    },

     {
      name: "Suggested Gemstones",
      selector: (row) => row.SuggestionGemstone,
      sortable: true,
       
    },
    
    {
      name: "Order Gemstone",
      selector: (row) => row.OrderGemstone,
      sortable: true,
      
    },
   
    {
      name: "Suggested Puja",
      selector: (row) => row.suggestionsPuja,
      sortable: true,
    }
   
  
  ];

 useEffect(()=>{
    fetchSummeryData()
  },[])






const handleSearch = () => {
    if (startTime ) {
      const formatDate = (dateTime) => {
        if (!dateTime) return null;
        const date = new Date(dateTime);
        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, "0");
        const dd = String(date.getDate()).padStart(2, "0");
        return `${yyyy}-${mm}-${dd}`;
      };

      const formattedStartDate = formatDate(startTime);
      const formattedEndDate = formatDate(endTime);

      const data = {
        FromDate: formattedStartDate,
        Todate: formattedEndDate,
      };

       
        fetchSummeryData()
    }
  };
  return (
   <>

  <div className="form-group  main_card">
      <h2 style={{ color: '#f7931e', fontWeight: 700 }}>User Summary</h2>
        <div className="row mt-3">
          <div className="col-3">
            <label className="form-label">Start Time</label>
            <input
              type="date"
              
              value={startTime}
              onChange={(e) => setStartTime(e.target.value)}
            />
          </div>
          <div className="col-3">
            <label className="form-label">End Time</label>
            <input
              type="date"
           
              value={endTime}
              onChange={(e) => setEndTime(e.target.value)}
            />
          </div>
        </div>
       
        <div className="row mt-3 ">
          
           <div className="col-3">
            <label className="form-label">User Id</label>
            <input
              type="number"
            
              value={userId}
              placeholder="Enter User Id"
              onChange={(e) => { setuserId(e.target.value)
              }}
            />
           
          </div>

       

          <div className="col-auto">
            <button className="btn btn-primary ms-2 mt-3" onClick={handleSearch}>
              Search
            </button>
          
          </div>
        </div>
      </div>

 <div className="col-12 mt-2  main_card">
        
          <DataTable
            dense
            data={summerydata || []}
            columns={columns}
            selectableRowsHighlight
            pagination
            customStyles={customStyles}
            persistTableHead={true}
            noDataComponent={"There are no data to display"}
          />
       
      </div>

   </>
  )
}

export default UserSummery;